
export const ClearCanvas = (context) => {
    context.clearRect(-250,-400,500,800);
}